import Glide, {
	Controls,
	Breakpoints,
	Autoplay,
	Swipe,
} from "@glidejs/glide/dist/glide.modular.esm";
import _ from "lodash";

const Sliders = {
	init() {
		function buildSlider(element) {
			const window_width =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;
			const margin = window_width / 10;
			let glide = new Glide(element, {
				hoverpause: false,
				type: "slider",
				perView: 1,
				autoplay: 4000,
				bound: true,
				animationDuration: 1200,
				gap: 0,
				animationTimingFunc: "cubic-bezier(0.645, 0.045, 0.355, 1.000)",
				// peek: {
				// 	before: margin,
				// 	after: margin + margin,
				// },
				breakpoints: {
					820: {
						perView: 1,
						// gap: 20,
						// peek: {
						// 	before: "20px",
						// 	after: "60px",
						// },
					},
				},
			});
			return glide;
		}

		// Convert wp-gallery-block with this class to glide slider.
		const glides = document.querySelectorAll(".gallery-slider");
		if (glides) {
			glides.forEach((el) => {
				var org_el = el.innerHTML;
				console.log(el.children.length);
				var buttons = "";
				for (var i = 0; i < el.children.length; i++) {
					el.children[i].classList.add("glide__slide");
					buttons +=
						"<button class='glide__bullet' data-glide-dir='=" +
						i +
						"'></button>";
				}
				var new_el =
					"<div class='glide' id='glide'>" +
					"<div class='glide__track' data-glide-el='track'>" +
					"<div class='glide__slides'>" +
					org_el +
					"</div>" +
					"<div class='glide__bullets' data-glide-el='controls[nav]'>" +
					buttons +
					"</div>" +
					"</div>" +
					"</div>";
				el.innerHTML = new_el;
				var _glide = buildSlider(el);

				_glide.mount({ Controls, Breakpoints, Autoplay, Swipe });
				window.addEventListener("resize", () => {
					setTimeout(() => {
						_glide.destroy();
						_glide = buildSlider(el);
						_glide.mount({
							Controls,
							Breakpoints,
							Autoplay,
							Swipe,
						});
					}, 1000);
				});
			});
		}
	},
};

export default Sliders;
